import { useEffect } from 'react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const useLockBodyScroll = (toggle, targetRef) => {
  useEffect(() => {
    const targetElement = targetRef.current;
    if (!toggle || !targetElement) {
      return;
    }
    disableBodyScroll(targetElement);
    return () => enableBodyScroll(targetElement);
  }, [targetRef, toggle]);
};

export { useLockBodyScroll };
//# sourceMappingURL=useLockBodyScroll.es.js.map
